<template>
  <div class="dashboard2-bd">
    <div class="dashboard-wrap">
      <img class="bg-img" src="../../images/dashboard/dashboard_bg.png" alt="" />
      <div class="bg-box">
        <div class="title">
          <h1>
            {{ userInfo.realName }},
            <span>{{ timeDay }}</span>
          </h1>
          <p>{{ $t('dashboard2.jtsoohyhdiynergyglpt', [today,weekday]) }}</p>
        </div>
      </div>
      <div class="report-box">
        <div class="report-card">
          <div class="pie-box">
            <dashboard-pie :pieData="pieData" v-if="pieData"></dashboard-pie>
          </div>
          <ul class="pie-list" v-if="pieData">
            <li class="ub">
              <div class="ub ub-f2 ub-xc">
                <div class="box" style="background: #00a0d9"></div>
                <div>{{ $t('dashboard2.kong_xian') }}</div>
              </div>
              <div class="ub-f1 tr">{{ $toFixed((countInfo.idle / countInfo.total) * 100, 0) }}%</div>
              <div class="ub-f1 tr">{{ countInfo.idle }}</div>
            </li>
            <li class="ub">
              <div class="ub ub-f2 ub-xc">
                <div class="box" style="background: #93da49"></div>
                <div>{{ $t('dashboard2.yun_xing_zhong') }}</div>
              </div>
              <div class="ub-f1 tr">{{ $toFixed((countInfo.using / countInfo.total) * 100, 0) }}%</div>
              <div class="ub-f1 tr">{{ countInfo.using }}</div>
            </li>
            <li class="ub">
              <div class="ub ub-f2 ub-xc">
                <div class="box" style="background: #ffad00"></div>
                <div>{{ $t('dashboard2.chong_dian_zhong') }}</div>
              </div>
              <div class="ub-f1 tr">{{ $toFixed((countInfo.charging / countInfo.total) * 100, 0) }}%</div>
              <div class="ub-f1 tr">{{ countInfo.charging }}</div>
            </li>
            <li class="ub">
              <div class="ub ub-f2 ub-xc">
                <div class="box"></div>
                <div>{{ $t('dashboard2.li_xian') }}</div>
              </div>
              <div class="ub-f1 tr">{{ $toFixed((countInfo.offline / countInfo.total) * 100, 0) }}%</div>
              <div class="ub-f1 tr">{{ countInfo.offline }}</div>
            </li>
            <div class="br"></div>
            <li class="ub">
              <div class="ub ub-f2 ub-xc">
                <div class="box" style="background: #eb5a5a"></div>
                <div>{{ $t('dashboard2.gu_zhang') }}</div>
              </div>
              <div class="ub-f1 tr">{{ $toFixed((countInfo.malfunction / countInfo.total) * 100, 0) }}%</div>
              <div class="ub-f1 tr">{{ countInfo.malfunction }}</div>
            </li>
          </ul>
        </div>
        <div class="report-container">
          <report-comp></report-comp>
        </div>
      </div>
      <div class="device-box">
        <div class="header">
          <div class="tab-box">
            <div style="display: flex">
              <el-tabs v-model="showType" style="height: 40px">
                <el-tab-pane :label="$t('dashboard2.she_bei_lie_biao')" name="device"></el-tab-pane>
                <el-tab-pane :label="$t('dashboard2.she_bei_di_tu')" name="map"></el-tab-pane>
              </el-tabs>
              <div class="status-tab">
                <ul>
                  <li class="item" :class="formSearch.state.includes('idle') ? 'active' : ''" @click="onStateChange('idle')">
                    <i class="point"></i>
                    <p>
                      {{ $t('dashboard2.kong_xian') }}
                      <span>({{ countInfo.idle }})</span>
                    </p>
                  </li>
                  <li class="item" :class="formSearch.state.includes('using') ? 'active' : ''" @click="onStateChange('using')">
                    <i class="point success"></i>
                    <p>
                      {{ $t('dashboard2.yun_xing_zhong') }}
                      <span>({{ countInfo.using }})</span>
                    </p>
                  </li>
                  <li class="item" :class="formSearch.state.includes('charging') ? 'active' : ''" @click="onStateChange('charging')">
                    <i class="point warning"></i>
                    <p>
                      {{ $t('dashboard2.chong_dian_zhong') }}
                      <span>({{ countInfo.charging }})</span>
                    </p>
                  </li>
                  <li class="item" :class="formSearch.state.includes('offline') ? 'active' : ''" @click="onStateChange('offline')">
                    <i class="point info"></i>
                    <p>
                      {{ $t('dashboard2.li_xian') }}
                      <span>({{ countInfo.offline }})</span>
                    </p>
                  </li>
                </ul>
              </div>
              <div style="margin-left: auto; margin-right: 0">
                <search-input v-model="formSearch.search" style="width: 250px" :placeholder="$t('dashboard2.jshsbmc')" @fetch="onPageChange({ page: 1 })"></search-input>
              </div>
            </div>
          </div>
        </div>
        <div class="map-container" v-if="showType === 'map'">
          <device-map :list="deviceList" :formSearch="formSearch"></device-map>
        </div>
        <div class="table-bd" v-if="showType === 'device'">
          <ul class="device-list" v-if="tableList.length > 0">
            <li class="li" v-for="item in tableList" :key="item.bodyNum" @click="onJumpDetails(item)">
              <div class="item">
                <div class="img-box" :class="{ gray: !getAttachUrl(item), offline: !item.isOnline }">
                  <img :src="getAttachUrl(item)" alt="" />
                </div>
                <div class="info">
                  <h3>{{ item.bodyNum }}</h3>
                  <p class="tag">
                    <span v-if="item.productCode">{{ item.productCode }}</span>
                    <span v-if="item.deviceName">{{ item.deviceName }}</span>
                    <span v-if="!formSearch.locationId && item.locationName">{{ item.locationName }}</span>
                    <span v-if="formSearch.locationId && item.siteName">{{ item.siteName }}</span>
                  </p>
                  <div class="state">
                    <div class="device-status-container" v-if="item.isOnline">
                      <ul class="device-status">
                        <!-- 电池 -->
                        <li class="battery" v-if="item.batteryCharge || item.batteryCharge === 0">
                          <div class="key">
                            <icon type="battery" :value="item.batteryCharge"></icon>
                          </div>
                          <div class="val">{{ item.batteryCharge || item.batteryCharge === 0 ? item.batteryCharge : '-' }}%</div>
                        </li>
                        <!-- 信号 -->
                        <li class="signal" v-if="(`${item.networkType}` === '1' && `${item.cellularMode}` === '1') || (`${item.networkType}` === '0' && `${item.cellularMode}` !== '1')">
                          <div class="key">
                            <!--
                            item.cellularMode
                              1-WIFI
                              2-2G
                              3-3G
                              4-4G
                          -->
                            <i v-if="`${item.networkType}` === '1' && `${item.cellularMode}` === '1'" class="icon-wifi-i" :class="wifi(item.wifiSignal)"></i>
                            <i v-else-if="`${item.networkType}` === '0' && `${item.cellularMode}` !== '1'" class="icon-signal-i" :class="signal(item.lteSignal)"></i>
                          </div>
                          <!--
                          networkType 和 cellularMode都为1显示
                          networkType 0和cellularMode不为1显示
                          其余不显示
                        -->
                          <div class="val" v-if="(`${item.networkType}` === '1' && `${item.cellularMode}` === '1') || (`${item.networkType}` === '0' && `${item.cellularMode}` !== '1')">
                            {{ getDicValue('dms_device_cellular_mode', item.cellularMode) || '-' }}
                          </div>
                          <!-- <div class="val">{{ item.networkType ? getDicValue('dms_device_network_type', item.networkType): '-' }}</div> -->
                        </li>
                        <!-- 温度 -->
                        <li class="temperature" v-if="item.batteryTemp || item.batteryTemp === 0">
                          <div class="key">
                            <!-- <i type="temperature" :value="item.batteryTemp"></i> -->
                            <icon type="temperature" :value="item.batteryTemp"></icon>
                          </div>
                          <div class="val">{{ $celsiusToFahrenheit(item.batteryTemp) }}{{ $formatTempUnit() }}</div>
                        </li>
                      </ul>
                    </div>
                    <div class="device-state">
                      <!-- {{statusList(item)}} -->
                      <div class="device-state-tag" v-for="(icon, index) in statusList(item)" :key="index" :class="{ 'has-name': icon.name }">
                        <i :class="icon.className"></i>
                        <!-- <span class="state-name">{{ item.name }}</span> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="point" :class="item.stateView"></div>
              </div>
            </li>
          </ul>
          <div class="no-data" v-else>{{ $t('Common.com_no_data') }}</div>
        </div>
        <div class="page-footer" v-if="showType === 'device'">
          <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange" radius></custom-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import icon from '@/components/icon.vue';
import dashboardPie from './children/dashboard_pie.vue';
import deviceMap from '../device/children/device_map.vue';
import reportComp from './children/dashboard_report.vue';

export default {
  name: 'dashboard',
  components: { deviceMap, reportComp, dashboardPie, icon },
  computed: {
    today() {
      const d = this.$moment(this.$getLocalTime()).format('MM/DD/YYYY');
      return d;
    },
    weekday() {
      const arr = [this.$t('dashboard2.xing_qi_ri'), this.$t('dashboard2.xing_qi_yi'), this.$t('dashboard2.xing_qi_er'), this.$t('dashboard2.xing_qi_san'), this.$t('dashboard2.xing_qi_si'), this.$t('dashboard2.xing_qi_wu'), this.$t('dashboard2.xing_qi_liu')];
      return arr[this.$moment(this.$getLocalTime()).get('days')];
    },
    timeDay() {
      const arr = [this.$t('dashboard2.ling_chen_hao'), this.$t('dashboard2.zao_shang_hao'), this.$t('dashboard2.shang_wu_hao'), this.$t('dashboard2.zhong_wu_hao'), this.$t('dashboard2.xia_wu_hao'), this.$t('dashboard2.wan_shang_hao')];
      const hour = moment(this.$getLocalTime()).hour();
      let timeOfDay = '';
      switch (true) {
        case hour >= 0 && hour < 6: // 凌晨
          timeOfDay = arr[0];
          break;
        case hour >= 6 && hour < 9: // 早上
          timeOfDay = arr[1];
          break;
        case hour >= 9 && hour < 12: // 上午
          timeOfDay = arr[2];
          break;
        case hour === 12: // 中午
          timeOfDay = arr[3];
          break;
        case hour > 12 && hour <= 17: // 下午
          timeOfDay = arr[4];
          break;
        default: // 其他情况都认为是晚上
          timeOfDay = arr[5];
      }
      return timeOfDay;
    },
  },
  data() {
    return {
      showType: '', // tab（设备/地图）
      formSearch: {
        type: '',
        pageNum: 1,
        pageSize: 50,
        customerId: '',
        customerName: '',
        locationId: '',
        locationName: '',
        siteId: '',
        siteName: '',
        productCode: '',
        mainState: '',
        secondState: '',
        state: '',
        search: '',
        status: '',
        tagName: '',
        tagId: '',
      },
      deviceList: [],
      tableList: [],
      totalRows: 0,
      countInfo: {},
      pieData: null,
    };
  },
  mounted: function () {
    this.getStatusCount();
    this.getFuncView(null, () => {
      this.showType = this.getJump('showType') || 'device';
      this.getMapTableList();
    });
    this.getTableList();
    this.getPieData();
  },
  methods: {
    getPieData() {
      this.$getJSON(apis.portalDeviceStatusCount).then((res) => {
        this.pieData = res.data || {};
      });
    },
    signal(val) {
      if (val >= 100) {
        return 'signal-xinhao100';
      }
      if (val >= 75) {
        return 'signal-xinhao75';
      }
      if (val >= 50) {
        return 'signal-xinhao50';
      }
      return 'signal-xinhao25';
    },
    wifi(val) {
      if (val >= 100) {
        return 'wifi100';
      }
      if (val >= 66) {
        return 'wifi66';
      }
      return 'wifi33';
    },
    // 设备分页列表
    getTableList() {
      this.$getJSON(apis.PortalDeviceAsmPage, this.formSearch).then(async (res) => {
        const deviceList = res.data.list || [];
        if (deviceList.length > 0) {
          const list = await this.formatAttachList(deviceList, 'productCodeId', 'dms.product.icon');
          this.tableList = list;
        } else {
          this.tableList = deviceList;
        }
        this.totalRows = res.data.total;
      });
    },
    // 设备地图设备
    getMapTableList() {
      this.$getJSON(apis.PortalDeviceAsmList, Object.assign({}, this.formSearch, { pageNum: undefined, pageSize: undefined })).then(async (res) => {
        const deviceList = res.data || [];
        if (deviceList.length > 0) {
          const list = await this.formatAttachList(deviceList, 'productCodeId', 'dms.product.icon');
          this.deviceList = list;
        } else {
          this.deviceList = deviceList;
        }
      });
    },
    // 设备状态icon列表
    statusList(item) {
      if (Object.keys(item).length) {
        const ret = [];
        const { lockState, isOnline, isPowerSave } = item;
        // 如果是离线状态，不显示其他实时状态(只有锁机 故障 省电)
        if (!isOnline) {
          // 显示锁机(自由锁1 账单锁2)
          if (lockState) {
            ret.push({
              type: 'lock',
              value: lockState,
              className: 'icon icon-locking gray',
              dicCode: 'isLock',
            });
          }
          // 是否省电模式
          if (isPowerSave) {
            ret.push({
              type: 'power',
              value: isPowerSave,
              className: 'icon icon-jieneng green',
              dicCode: 'isPowerSave',
            });
          }
        } else {
          if (lockState) {
            ret.push({
              type: 'lock',
              value: lockState,
              className: 'icon icon-suoji gray',
              dicCode: 'isLock',
            });
          }
          if (isPowerSave) {
            ret.push({
              type: 'power',
              value: isPowerSave,
              className: 'icon icon-jieneng green',
              dicCode: 'isPowerSave',
            });
          }
        }
        return ret;
      }
      return [];
    },
    // 获取数量统计
    getStatusCount() {
      this.$getJSON(apis.portalDeviceStatusCount, this.formSearch).then((res) => {
        const data = res.data;
        this.countInfo = data;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
      this.getStatusCount();
      this.getMapTableList();
    },
    // 切换状态
    onStateChange(type) {
      if (this.formSearch.state.includes(type)) {
        this.formSearch.state = this.formSearch.state.filter(item => item !== type);
      } else {
        this.formSearch.state = [...this.formSearch.state, type];
      }
      this.onPageChange({ page: 1 });
    },
    // 跳转详情
    onJumpDetails(item) {
      this.jump('/dashboard/accountDeviceDetail', {
        bodyNum: item.bodyNum,
        deviceId: item.deviceId,
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.dashboard2-bd {
  padding: 0 24px 24px;
  .dashboard-wrap {
    position: relative;
    padding: 0 20px;
    overflow: hidden;
    border-radius: 16px 16px 0px 0px;
    &:after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      height: 150px;
      z-index: 1;
      background: linear-gradient(#f1f1f2 0%, #f8f9fa 100%);
    }
    .title {
      padding: 20px 0;
      h1 {
        height: 28px;
        line-height: 28px;
        margin-bottom: 8px;
        font-size: 20px;
        color: #0d9ae0;
        font-weight: bold;
        span {
          color: #1a1a1a;
        }
      }
      p {
        color: #4d4d4d;
        font-size: 14px;
        line-height: 20px;
      }
    }
    .bg-img {
      display: block;
      position: absolute;
      right: 0;
      z-index: 2;
    }
    .bg-box {
      position: relative;
      z-index: 10;
    }
  }

  .report-box {
    position: relative;
    z-index: 20;
    display: flex;
    height: 504px;
    .report-card {
      width: 311px;
      margin-right: 16px;
      box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.03);
      border-radius: 16px;
      background-color: #ffffff;
      padding: 12px 0;
      .pie-box {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 19px;
        padding-bottom: 7px;
        & > div {
          height: 230px;
          width: 230px;
        }
      }
      .pie-list {
        padding: 0 40px;
        .br {
          margin: 13px 8px;
          height: 1px;
          background: #f5f5f5;
        }
        li {
          height: 23px;
          line-height: 23px;
          font-size: 14px;
          color: #1a1a1a;
          margin-bottom: 5px;
          .box {
            width: 12px;
            height: 12px;
            border-radius: 2px;
            background: #b3b3b3;
            margin-right: 16px;
          }
          .tr {
            text-align: right;
          }
        }
      }
    }
    .report-container {
      box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.03);
      border-radius: 16px;
      background-color: #ffffff;
      overflow: hidden;
      flex: 1;
    }
  }

  .device-box {
    background-color: #ffffff;
    border-radius: 16px;
    margin-top: 24px;
    .header {
      padding: 24px;
      .status-tab {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        ul {
          display: flex;
          li {
            height: 32px;
            line-height: 32px;
            border-radius: 47px;
            border: 1px solid #efefef;
            margin-right: 8px;
            padding: 0 12px;
            font-size: 0;
            display: flex;
            align-items: center;
            cursor: pointer;
            &.active {
              background: $--color-primary;
              p {
                color: #fff;
                font-family: PingFangSC-Semibold, PingFang SC;
                span {
                  color: #fff;
                  font-family: PingFangSC-Regular, PingFang SC;
                }
              }
              .point {
                //  border: none;
                background-color: #fff !important;
              }
            }
            p {
              margin-left: 8px;
              font-size: 12px;
              color: #333333;
              line-height: 32px;
              font-size: 12px;
              font-weight: bold;
              color: $--color-text-regular;
              line-height: 18px;
              span {
                font-size: 12px;
                margin-left: 4px;

                color: $--color-text-secondary;
                line-height: 18px;
              }
            }
            .point {
              width: 10px;
              height: 10px;
              display: inline-block;
              background: $--color-primary;
              // border: 3px solid #e5e5e5;
              border-radius: 50%;

              &.danger {
                background: $--color-danger;
              }

              &.warning {
                background: $--color-warning;
              }
              &.success {
                background: $--color-success;
              }
              &.info {
                background: $--color-info;
              }
            }
          }
        }
      }
    }

    .table-bd {
      height: 462px;
      width: 100%;
      overflow: hidden;
      padding: 0 24px;
      .device-list {
        display: flex;
        flex-flow: row wrap;
        // justify-content: space-between;
        height: 472px;
        // height: 100%;
        align-content: flex-start;
        margin-top: -10px;
        overflow-y: auto;
        .li {
          margin-top: 10px;
          margin-right: 10px;
          width: calc(33.3% - 10px);
          flex: 0 0 calc(33.3% - 10px);
          height: 108px;
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #f4f4f4;

          padding: 16px;
          cursor: pointer;
          overflow: hidden;
          // align-items: center;
          // justify-content: center;
          &:hover {
            border-color: $--color-primary;
          }
          &:nth-child(3n + 3) {
            margin-right: 0;
          }
          .item {
            display: flex;
            position: relative;
            .img-box {
              width: 46px;
              height: 46px;
              flex: 0 0 46px;
              img {
                max-width: 100%;
                max-height: 100%;
              }
              &.gray {
                background: #f5f5f5;
              }
              &.offline {
                /** 图片去色 */
                -webkit-filter: grayscale(100%);
                -moz-filter: grayscale(100%);
                -ms-filter: grayscale(100%);
                -o-filter: grayscale(100%);
                filter: grayscale(100%);
                filter: gray;
              }
            }
            .info {
              flex: 1;
              margin-left: 16px;
              h3 {
                height: 20px;
                font-size: 16px;
                font-weight: bold;
                color: $--color-text-regular;
                line-height: 20px;
              }
              p {
                padding: 8px 0 12px 6px;
                display: flex;
                overflow: hidden; //超出隐藏
                span {
                  padding: 0 6px;
                  margin-right: 8px;
                  height: 18px;
                  background: #f4f4f4;
                  border-radius: 100px;
                  line-height: 18px;
                  font-size: 12px;
                  white-space: nowrap; //不换行
                  overflow: hidden; //超出隐藏
                  text-overflow: ellipsis; //变成...
                }
              }
              .state {
                display: flex;
                // height: 22px;
                // line-height: 22px;

                .device-status-container {
                  // text-align: center;
                  font-size: 0;
                  // width: 140px;
                  margin-right: 26px;
                  .device-status {
                    font-size: 12px;
                    color: #4d4d4d;
                    // margin-top: 24px;
                    overflow: hidden;
                    display: inline-block;

                    > li {
                      float: left;
                      height: 22px;
                      &:nth-child(n + 2) {
                        margin-left: 10px;
                      }
                      &.signal {
                        .val {
                          padding-left: 2px;
                        }
                      }
                      .key {
                        float: left;
                        color: #00a0d9;
                        .icon {
                          float: left;
                          font-size: 18px;
                          line-height: 22px;
                        }
                      }
                      .val {
                        float: left;
                        margin-left: 2px;
                        line-height: 22px;
                      }

                      .icon-wifi-i,
                      .icon-signal-i {
                        float: left;
                        // display: inline-block;
                        height: 18px;
                        width: 18px;
                        margin-top: 2px;
                        line-height: 22px;
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: 100%;
                      }
                      .signal-xinhao100 {
                        background-image: url('~@/images/layout/icon-signal-100.svg');
                      }
                      .signal-xinhao75 {
                        background-image: url('~@/images/layout/icon-signal-75.svg');
                      }
                      .signal-xinhao50 {
                        background-image: url('~@/images/layout/icon-signal-50.svg');
                      }
                      .signal-xinhao25 {
                        background-image: url('~@/images/layout/icon-signal-25.svg');
                      }
                      .wifi100 {
                        background-image: url('~@/images/layout/icon-wifi-100.svg');
                      }
                      .wifi66 {
                        background-image: url('~@/images/layout/icon-wifi-66.svg');
                      }
                      .wifi33 {
                        background-image: url('~@/images/layout/icon-wifi-33.svg');
                      }
                    }
                  }
                }
                .device-state {
                  // position: absolute;
                  // top: 16px;
                  // right: -8px;

                  .device-state-tag {
                    $r: 22px;
                    // width: $r;
                    // height: $r;
                    border-radius: $r / 2;
                    // background: rgba(13, 154, 224, 0.05);
                    overflow: hidden;
                    float: left;
                    &.has-name {
                      // width: auto;
                      // padding-right: 10px;
                      line-height: $r;
                      .icon {
                        // margin-left: 9px;

                        &.icon-cleaning,
                        &.icon-free {
                          font-size: 18px;
                        }

                        &.icon-cleaning {
                          margin-top: 5px;
                        }
                        &.icon-suspend,
                        &.icon-free,
                        &.icon-charge {
                          margin-top: 4px;
                        }

                        &.icon-machine-offline {
                          margin-top: 5px;
                          font-size: 18px;
                        }
                      }
                    }
                    &:nth-child(n + 2) {
                      margin-left: 6px;
                    }

                    .icon {
                      $r: 18px;
                      width: $r;
                      height: $r;
                      text-align: center;
                      line-height: $r;
                      float: left;
                      margin-top: 3px;
                      margin-left: 3px;
                      font-size: 18px;

                      // &.icon-machine-offline,

                      &.blue {
                        color: $--color-primary;
                      }

                      &.red {
                        color: $--color-danger;
                      }
                      &.yellow {
                        color: $--color-warning;
                      }
                      &.gray {
                        color: $--color-info;
                      }
                      &.green {
                        color: $--color-success;
                      }
                    }

                    .state-name {
                      float: left;
                      font-size: 12px;
                      color: #495057;
                      margin-left: 3px;
                    }
                  }
                }
              }
            }
            .point {
              position: absolute;
              right: 0;
              top: 0;
              display: inline-block;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: $--color-info;
              &.idle {
                background-color: $--color-primary;
              }
              &.running {
                background-color: $--color-success;
              }
              &.charging {
                background-color: $--color-warning;
              }
              &.offline {
                background-color: $--color-info;
              }
            }
          }
        }
      }
      .no-data {
        font-size: 16px;
        line-height: 140%;
        color: #818181;

        width: 100%;
        display: flex;
        height: 496px;
        justify-content: center;

        align-items: center;
        background-color: #fff;
      }
    }

    .page-footer {
      height: 88px;
    }

    .map-container {
      height: 574px;
      padding: 0 24px 24px;
      & > div {
        border: 1px solid #00a0d9;
        border-radius: 16px;
      }
    }
  }
}
</style>
